/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export enum TransactionSubTypeApiModel {
  Sale = 'sale',

  SpecialAccountRefill = 'special-account-refill',

  SpecialAccountRefillDirect = 'special-account-refill-direct',

  SpecialAccountRefillByCustomer = 'special-account-refill-by-customer',

  SpecialAccountWriteOffsDirect = 'special-account-write-offs-direct',

  SpecialAccountWriteOffsLoan = 'special-account-write-offs-loan',

  SpecialAccountWriteOffsScheduled = 'special-account-write-offs-scheduled'
}
